import Link from 'next/link';
import type { CategoryData } from '@/types/public-menu';
import { getContextualHref } from '@/lib/domains';
import { sized } from '../grocery-utils';

export function AisleTiles({ aisles, slug }: { aisles: CategoryData[]; slug: string }) {
  if (!aisles.length) return null;
  return (
    <section aria-label="Shop by aisle" className="gh-wrap gh-section">
      <h2 className="gh-h2">Shop by aisle</h2>
      <div className="gh-aisles">
        {aisles.map((c) => {
          const img = c.imageUrl || c.menuItems.find((i) => i.imageUrl)?.imageUrl;
          return (
            <Link key={c.id} href={getContextualHref(slug, `/aisle/${c.id}`)} className="gh-aisle gh-tile">
              {img ? <img src={sized(img, 480)} alt="" loading="lazy" decoding="async" /> : <span className="gh-aisle-ph" />}
              <span className="gh-aisle-label">
                <strong>{c.name}</strong>
                <span>{c.menuItems.length} product{c.menuItems.length !== 1 ? 's' : ''}</span>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}
